var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.4c-5 0-9.42-2.56-12-6.4.06-4 8-6.2 12-6.2S31.94 24 32 28a14.465 14.465 0 0 1-12 6.4zM20 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0-6a20 20 0 1 0 20 20C40 8.94 31 0 20 0z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.b36d320c69606bae52bf953107845d69.svg";
export { ForwardRef as ReactComponent };